<template>
  <bk-view v-if="show" class="statusTag-container" :class="['view-status-'+status, curRows.bizScene]">
    <bk-lang :code="langCode_status"></bk-lang>
  </bk-view>
</template>

<script>
export default {
  name:'statusTag',
  props:{
    curRows:Object,
  },
  computed:{
    show(){
      const { bizScene } = this.curRows;
      
      if(bizScene==='waiting'){
        return [0, 1].includes(this.status);
      }
      return [0,2].includes(this.status);
    },
    status(){
      const { status, avaBookStatus, bizScene } = this.curRows;
      
      if(bizScene==='waiting'){
        return avaBookStatus;
      }
      return status;
    },
    langCode_status(){
      const {  bizScene } = this.curRows;

      if(bizScene==='waiting'){
        return {
          0:'appointment_waiting',
          1:'appointment_slotAvailable'
        }[this.status]
      }

      return {
        0:'appointment_tobeConfirmed',
        2:'appointment_rejected'
      }[this.status]
    }
  }
}
</script>

<style lang="less">
 .statusTag-container.bk-view{
    position: absolute;
    top: 0;
    right: 0;
    height: 26px;
    display: inline-flex;
    align-items: center;
    border-radius: 0px 12px 0px 12px;
    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
    font-weight: 600;
    font-size: 12px;
    color: #FFFFFF;
    padding: 0 10px;
    &.reserve{
      &.view-status-0{
        background: #2E56F2;
      } 
      &.view-status-2{
        background: #FF7A68;
      }
    }
    &.waiting{
      &.view-status-0{
        background: #2DAB40;
      } 
      &.view-status-1{
        background: #2E56F2;
      }
    }
  }
</style>